// extracted by mini-css-extract-plugin
export default {"mainContainer":"CardLiquidacionRuta_mainContainer__BV5xC","cardContainer":"CardLiquidacionRuta_cardContainer__l1+3E"};